<template>
  <div class="proxyIpRecord">
    <NavBar title="代理记录"></NavBar>
    <div class="main" v-if="recordShow">
      <div class="jlcard" v-for="(item, index) in recordlist" :key="index">
        <div class="jlcr_top">
          <p>设备名称：{{ item.instanceName }}</p>
          <div class="cancel" @click="cancelProxyIp(item)">取消代理</div>
        </div>
        <div class="jlcr_main_box">
          <div class="jlcr_main">
            <p>代理IP：{{ item.proxyIp }}</p>
            <p>服务器端口：{{ item.serverPort }}</p>
            <p>用户名：{{ item.account }}</p>
            <p>密码：{{ item.password }}</p>
          </div>
        </div>
      </div>
    </div>
    <van-empty
      v-else
      class="custom-image"
      :image="require('@/assets/imgs/empty.png')"
      description="暂时没有可代理的云手机哦！"
    />
  </div>
</template>

<script>
import {
  authorizerecordlist,
  instancelist,
  userProxyIpRecord,
  setUserProxyIp,
} from "@/api/index.js";
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
export default {
  name: "proxyIpRecord",
  components: {
    NavBar,
  },
  data() {
    return {
      recordlist: [],
      instanceList: [],
      recordShow: true,
    };
  },

  mounted() {
    this.getUserProxyIpRecord();
  },

  methods: {
    // 获取授权记录列表
    async getUserProxyIpRecord() {
      await instancelist().then((res) => {
        if (res.code == 200) {
          this.instanceList = res.data;
          let instanceCodes = res.data.map(function (item) {
            return item.instanceCode;
          });
          userProxyIpRecord({
            instanceCodes,
          }).then((res) => {
            if (res.code == 200) {
              this.recordlist = res.rows;
              if (this.recordlist.length <= 0) {
                this.recordShow = false;
              }
            }
          });
        } else {
          Toast(res.msg);
        }
      });
    },
    cancelProxyIp(item) {
      this.handleProxyIp([item]);
    },
    handleProxyIp(list) {
      let bdScriptContent = `dg config -a proxy.enabled=false;dg apt uninstall plugin:proxy`;
      let intelligentScriptContent = `gm config -a "proxy.enabled=false"`;
      let hwScriptContent = `proxy -r socks5 -c`;
      let ids = this.instanceList
        .filter((item) =>
          list.some((list) => {
            return item.instanceCode == list.instanceCode;
          })
        )
        .map(function (item) {
          return item.instanceId;
        });
      let appUserInstanceProxyIpRecordList = list.map(function (item) {
        return {
          id: item.id,
          instanceCode: item.instanceCode,
          account: item.account,
          password: item.password,
          proxyIp: item.proxyIp,
          serverPort: item.serverPort,
        };
      });
      let data = {
        appUserInstanceProxyIpRecordList,
        bdScriptContent,
        hwScriptContent,
        ids,
        intelligentScriptContent,
        operationType: 1,
      };
      setUserProxyIp(data).then((res) => {
        this.getUserProxyIpRecord();
        Toast(res.msg);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.proxyIpRecord {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  padding: 10px 16px 16px 16px;
  .jlcard {
    margin-bottom: 12px;
    padding-bottom: 16px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    .jlcr_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px;
      border-bottom: 1px solid rgb(239, 239, 239);
      box-sizing: border-box;
      width: 100%;
      p {
        margin: 0;
        flex: 1;
        color: rgb(30, 33, 51);
        font-family: 思源黑体;
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0px;
        text-align: left;
      }
      span {
        color: rgb(46, 111, 250);
        font-family: 思源黑体;
        font-size: 15px;
        font-weight: 400;
        line-height: 22px;
        text-align: right;
      }
      .cancel {
        width: 84px;
        border-radius: 18px;
        border: 1px solid #89afff;
        font-size: 14px;
        color: #0066ff;
        line-height: 25px;
      }
    }
    .jlcr_main_box {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .jlcr_main {
        text-align: left;
        p {
          margin: 10px 0 0 20px;
          height: 20px;
          color: rgb(30, 33, 51);
          font-family: 思源黑体;
          font-size: 15px;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
        }
      }
      .cancel {
        width: 84px;
        height: 30px;
        border-radius: 18px;
        border: 1px solid #89afff;
        font-size: 14px;
        color: #0066ff;
        line-height: 30px;
        margin-right: 16px;
      }
    }
  }
}
.mains {
  margin-top: 200px;
  img {
    width: 200px;
    height: 200px;
  }
  p {
    margin: 0;
    height: 22px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
  }
}
</style>